import type { RawParams } from "@uirouter/react";
import dayjs from "dayjs";

import { swSettings } from "app/common/services/swSettings";
import { i18nFilter } from "app/filters/i18nFilter";
import { APP_CATEGORY_LEADERBOARD, APP_CATEGORY_TRENDS } from "app/pages/sales-intelligence/constants/routes";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

let selectedTab: string | undefined;
const getPageTitle = (pageState: IRouterState, params: RawParams) => {
    // state pageTitle (string or Getter)
    const pageTitle = typeof pageState.pageTitle === "function" ? pageState.pageTitle(params) : pageState.pageTitle;

    switch (pageState.name) {
        case "digitalsuite_app_usersengagement":
        case "digitalsuite_app_appperformance":
            return i18nFilter()(pageTitle ?? "");

        default:
            return i18nFilter()(pageTitle ?? "");
    }
};
const getPageSubtitle = (pageState: FixmeType) => {
    // state pageSubtitle (string or Getter)
    switch (pageState.name) {
        case APP_CATEGORY_LEADERBOARD:
        case APP_CATEGORY_TRENDS:
            return pageState.pageSubtitle
                ? i18nFilter()(pageState.pageSubtitle) +
                      ` ` +
                      dayjs.utc(swSettings.current.resources.SupportedDate).format("MMMM DD, YYYY")
                : null;
        default:
            return pageState.pageSubtitle ? i18nFilter()(pageState.pageSubtitle) : null;
    }
};
// to support the orange badge in tab base pages.
// to add the badge to your tab add tab name to the "showInTabs" array
const getOrangeBadgeTitle = (pageState: FixmeType) => {
    const { orangeBadgeTitle } = pageState;
    const i18n = i18nFilter();
    const showInTabs = ["plaResearch"];

    if (typeof orangeBadgeTitle === "function") {
        return i18n(orangeBadgeTitle());
    }

    if (orangeBadgeTitle) {
        return i18n(orangeBadgeTitle);
    }
    if (selectedTab && showInTabs.includes(selectedTab)) {
        return i18n("sidenav.new");
    }
    return null;
};

const getData2BadgeTitle = (pageState: IRouterState) => {
    const { dataBadgeTooltip } = pageState;
    if (typeof dataBadgeTooltip === "function") {
        return dataBadgeTooltip();
    } else {
        return dataBadgeTooltip;
    }
};

export const getPageSettings = (pageState: IRouterState, params: RawParams) => {
    const pageTitle = getPageTitle(pageState, params);
    const pageSubtitle = getPageSubtitle(pageState);
    const translate = i18nFilter();
    const {
        isPdfDownloadButton,
        hasExcelDownloadButton,
        pageTitleTooltip,
        pdfDownloadsMethod,
        excelDownloadsMethod,
        closeDelayBadgeTooltip,
        customPdfComponent,
    } = pageState ?? {};
    const downloadExcelPermitted =
        typeof pageState.downloadExcelPermitted === "function"
            ? pageState.downloadExcelPermitted()
            : pageState.downloadExcelPermitted;
    const orangeBadgeTitle = getOrangeBadgeTitle(pageState);
    const GreenBadgeTitleComponent = pageState.getGreenBadgeTitleComponent;
    const pinkBadgeTitle = pageState.pinkBadgeTitle ? translate(pageState.pinkBadgeTitle) : null;
    const pinkBadgeTooltip = pageState.pinkBadgeTooltip && translate(pageState.pinkBadgeTooltip);
    const dataBadgeTitle = pageState.dataBadgeTitle ? translate(pageState.dataBadgeTitle) : null;
    const dataBadgeTooltip = pageState.customData?.dataBadgeTooltip && getData2BadgeTitle(pageState);
    const allowHoverDataBadgeTooltip = pageState.customData?.allowHoverDataBadgeTooltip as boolean | undefined;

    return {
        pageTitle,
        pageSubtitle,
        pageTitleTooltip,
        isPdfDownloadButton,
        pdfDownloadsMethod,
        hasExcelDownloadButton,
        excelDownloadsMethod,
        downloadExcelPermitted,
        orangeBadgeTitle,
        GreenBadgeTitleComponent,
        pinkBadgeTitle,
        pinkBadgeTooltip,
        dataBadgeTitle,
        dataBadgeTooltip,
        isPdfDownload: false,
        allowHoverDataBadgeTooltip,
        closeDelayBadgeTooltip,
        customPdfComponent,
    };
};
